<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="flex-between flex-center">
				<div class="user-login-title"><a href="/">首页</a>/个人中心/<span>积分账户</span></div>
			</div>
			
			<div class="order-bg">
				<div class="order-status flex-start flex-center">
					<div class="active">我的积分：{{user.integral}}</div>
				</div>
				<div class="order-list" v-if="total > 0">
					<div class="item flex-between flex-center" v-for="item in list" :key="item.id">
						<div class="item-left">
							<div>{{item.title}}</div>
							<div>{{item.createTime}}</div>
						</div>
						<div class="item-right">{{item.changeIntegral}}</div>
					</div>
				</div>
				<div class="page" v-if="total > 0">
				    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
				</div>
				<noData v-if="list.length == 0 && isLoad == true" msg="暂无数据"></noData>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import noData from '@/components/noData.vue'
import {userIntegralLog} from "@/api/user"
export default {
	name: 'index',
	components:{
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:20,
			total:0,
			isLoad:false
		}
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.isLoad = false;
		this.$store.dispatch('fetchUser');
		this.page = 1;
		this.getList();
	},
	methods:{
		getList(){
			userIntegralLog({page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		getTop(){
			this.isLoad = false;
			this.page = 1;
			this.getList();
		},
	}
}
</script>

<style lang="scss" scoped>
	.item{
		border-bottom: 1px solid #EEEEEE;
		padding: 24px;
		.item-left{
			div{
				&:first-of-type{
					opacity: 0.8;
					font-size: 16px;
					line-height: 40px;
					color: #16181B;
				}
				&:last-of-type{
					opacity: 0.8;
					font-size: 14px;
					color: #16181B;
		
				}
			}
		}
		.item-right{
			font-size: 16px;
			font-weight: 500;
			text-align: right;
			color: #16181B;
		
		}
	}
	
	.no-data{
		width: 100%;
		padding: calc(50vh - 400px) 0px;
		background: #FFFFFF;
		text-align: center;
		img{
			width: 120px;
			height: 120px;
		}
		div{
			font-size: 16px;
			font-weight: 500;
			color: #9E9E9E;
			margin-top: 12px;
		}
	}
	.order-list{
		min-height: 680px;
		background-color: #fff;
	}
	
	.order-status{
		width: 100%;
		height: 80px;
		border-radius: 8px;
		background: #F8F8F8;
		padding: 0px 20px;
		box-sizing: border-box;
		div{
			padding: 0px 0px 6px;
			font-size: 26px;
			color: #070B13;
			cursor: pointer;
			color: #E91A12;
			font-weight: bold;
		}
	}
	.order-bg{
		background: #fff;
		padding: 40px;
	}
	
</style>
